import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Pendiente } from '../models/pendiente';

@Injectable()
export class PendientesService {

  constructor(private afDB:AngularFireDatabase) { }

  /**
   * Obtiene los pendientes por creador
   * @param uid 
   */
  public obtenerPendientesPorCreador(uid){
    return this.afDB.list('pendientesPorCreador/' + uid + '/');
  }

  /**
   * Obtiene los pendientes por responsable
   * @param uid 
   */
  public obtenenerPendientesAsignados(uid){
    return this.afDB.list('/pendientesPorResponsable/' + uid + '/');
  }

  /**
   * Obtiene la información de un pendiente
   * @param idPendiente 
   */
  public obtenerPendiente(idPendiente){
    return this.afDB.object('/pendientes/' + idPendiente + '/');
  }

  /**
   * Crea un nuevo pendiente
   * @param pendiente 
   */
  public crearPendiente(pendiente:Pendiente){
    // Genera la primer nota
    if(pendiente.notas.trim().length > 0){
      let notaKey = this.afDB.list('/').push(undefined).key;
      let objNota = {
        autor : pendiente.creador,
        nota : pendiente.notas
      };
      pendiente.notas = {};
      pendiente.notas[notaKey] = objNota;
    }
    
    let fechaSeparada = pendiente.vencimiento.split('-');
    pendiente.vencimiento = new Date(Number(fechaSeparada[0]), Number(fechaSeparada[1]) - 1, Number(fechaSeparada[2])).valueOf();
    
    // Crea el pendiente
    const pendienteKey = this.afDB.list('/').push(undefined).key;
    let multipath = {};
    multipath['pendientes/' + pendienteKey + '/'] = pendiente;
    multipath['pendientesPorCreador/' + pendiente.creador + '/' + pendienteKey + '/'] = pendiente;
    multipath['pendientesPorResponsable/' + pendiente.responsable + '/' + pendienteKey + '/'] = pendiente;
    return this.afDB.object('/').update(multipath);
  }

  /**
   * Marca un pendiente como finalizado
   * @param idPendiente 
   * @param pendiente
   */
  public marcarComoFinalizado(idPendiente:string, pendiente:Pendiente){
    let multipath = {};
    multipath['pendientes/' + idPendiente + '/finalizado/'] = true;
    multipath['pendientesPorCreador/' + pendiente.creador + '/' + idPendiente + '/finalizado/'] = true;
    multipath['pendientesPorResponsable/' + pendiente.responsable + '/' + idPendiente + '/finalizado/'] = true;
    return this.afDB.object('/').update(multipath);
  }

  /**
   * Reabre un pendiente previamente finalizado
   * @param idPendiente 
   * @param pendiente 
   */
  public reabrir(idPendiente:string, pendiente:Pendiente){
    let multipath = {};
    multipath['pendientes/' + idPendiente + '/finalizado/'] = false;
    multipath['pendientesPorCreador/' + pendiente.creador + '/' + idPendiente + '/finalizado/'] = false;
    multipath['pendientesPorResponsable/' + pendiente.responsable + '/' + idPendiente + '/finalizado/'] = false;
    return this.afDB.object('/').update(multipath);
  }


  public confirmar(idPendiente:string, pendiente:Pendiente){
    let multipath = {};
    multipath['pendientes/' + idPendiente + '/confirmado/'] = true;
    multipath['pendientesPorCreador/' + pendiente.creador + '/' + idPendiente + '/confirmado/'] = true;
    multipath['pendientesPorResponsable/' + pendiente.responsable + '/' + idPendiente + '/confirmado/'] = true;
    return this.afDB.object('/').update(multipath);
  }

  /**
   * Se agrega la nota en el pendiente
   * @param idPendiente 
   * @param nota 
   * @param autor
   */
  public agregarNota(idPendiente:string, nota:string, autor:string){
    let objNota = { nota, autor };
    return this.afDB.list('/pendientes/' + idPendiente + '/notas/').push(objNota);
  }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/pendientes.service.ts